import styled from 'styled-components'

export const PresetSection = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
  display: grid;
  gap: 10px;
  padding-bottom: 24px;
`

export const PresetHeading = styled.div`
  color: ${({ theme }) => theme.palette.colors.text};
  font-size: 15px;
  font-weight: 800;
`

export const PresetDescription = styled.p`
  color: ${({ theme }) => theme.palette.colors.muted};
  font-size: 13px;
  line-height: 1.45;
  margin: 0;
`

export const PresetMessage = styled.div`
  color: ${({ error, theme }) => error ? theme.palette.error.main : theme.palette.colors.muted};
  font-size: 12px;
  font-weight: 700;
`

export const AppliedPreset = styled.div`
  background: ${({ theme }) => theme.palette.colors.buttonGhost};
  border: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
  border-radius: 10px;
  display: grid;
  gap: 10px;
  padding: 14px;
`

export const AppliedHeader = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 16px;
  justify-content: space-between;
`

export const AppliedName = styled.div`
  color: ${({ theme }) => theme.palette.colors.text};
  font-size: 14px;
  font-weight: 800;
`

export const AppliedDescription = styled.div`
  color: ${({ theme }) => theme.palette.colors.muted};
  font-size: 12px;
  margin-top: 3px;
`

export const PresetList = styled.div`
  border-top: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
  display: grid;
  max-height: 220px;
  overflow-y: auto;
  padding-top: 4px;
`

export const PresetItem = styled.div`
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
  color: ${({ theme }) => theme.palette.colors.text};
  display: flex;
  font-size: 13px;
  gap: 12px;
  justify-content: space-between;
  min-height: 38px;

  &:last-child {
    border-bottom: 0;
  }
`

export const PresetType = styled.span`
  color: ${({ theme }) => theme.palette.colors.subdued};
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
`
